import { log, isEmpty, ucFirst, notEmpty, cmpInt } from '../helpers/general';
import { general } from '../helpers';
import _ from 'lodash';
import moment from 'moment';

const months = [
    { month: 1, partial: "jan", full: "January" },
    { month: 2, partial: "feb", full: "Feburary" },
    { month: 3, partial: "mar", full: "March" },
    { month: 4, partial: "apr", full: "April" },
    { month: 5, partial: "may", full: "May" },
    { month: 6, partial: "jun", full: "June" },
    { month: 7, partial: "jul", full: "July" },
    { month: 8, partial: "aug", full: "August" },
    { month: 9, partial: "sep", full: "September" },
    { month: 10, partial: "oct", full: "October" },
    { month: 11, partial: "nov", full: "November" },
    { month: 12, partial: "dec", full: "December" },
];

/**
 * Get a list of months in a json object
 * @returns {{}}
 */
export function getListOfMonths () {
    let monthsObject = {};
    for (let i = 0; i < months.length; i++) {
        const month = months[i];
        monthsObject[month.month] = { partial: month.partial, full: month.full };
    }
    return monthsObject;
}

/**
 * generate list of months for select input
 * @returns {Array}
 */
export function getMonths () {
    var monthsData = [];
    for (var i = 0; i < months.length; i++) {
        var month = months[i];
        monthsData.push({
            value: month.month,
            text: _.padStart(month.month, 2, '0')
        });
    }
    return monthsData;
}

/**
 * generate list of months for select input
 * @returns {Array}
 */
export function getMonthsWithLabelName () {
    var monthsData = [];
    for (var i = 0; i < months.length; i++) {
        var month = months[i];
        monthsData.push({
            value: month.month,
            text: month.full
        });
    }
    return monthsData;
}

/**
 * generate list of years for select input
 * @returns {Array}
 */
export function getYears () {
    var currentYear = parseInt((new Date()).getFullYear(), 10);
    var yearsData = [];
    for (var i = currentYear; i <= (currentYear + 20); i++) {
        yearsData.push({
            value: String(i),
            text: String(i)
        });
    }
    return yearsData;
}

/**
 * add year to date
 * Note: copied from webapp_admin
 * @param date
 * @param years
 * @returns {*}
 */
export function addYearToDate (date, years) {
    if (!isEmpty(date) && !isEmpty(years)) {
        var momentDate = moment(date);
        momentDate.add(years, 'years');
        return momentDate;
    } else {
        return '';
    }
}

/**
 * get difference between two dates
 * @param from
 * @param to
 * @returns {number}
 */
export function getDaysBtwDates (from, to) {
    if (typeof from !== typeof undefined && typeof to !== typeof undefined) {
        to = moment(to);
        from = moment(from);

        var toMonthYear = to.toDate(),
            fromMonthYear = from.toDate();

        // set year to current year if date to has no year provided
        if (parseInt(to.format('YYYY')) < (new Date().getFullYear())) {
            toMonthYear.setYear((new Date()).getFullYear());
        }
        
        if (fromMonthYear > toMonthYear) {
            toMonthYear = addYearToDate(toMonthYear, 1);
        }

        var daysLeft = Math.abs(moment(fromMonthYear).diff(moment(toMonthYear), 'days')) + 1;
        if (cmpInt(daysLeft, 365)) {
            return 0;
        } else {
            return daysLeft;
        }
    } else {
        return 0;
    }
}

export function calculateAGM_SG (yearEnd) {
    return yearEnd ? moment(yearEnd).add(6, 'M') : '';
}

export function calculateAR_SG (agm) {
    return agm ? moment(agm).add({days: 30}) : '';
}

export function calculcateECI_SG (yearEnd) {
    return yearEnd ? moment(yearEnd).add(3, 'M').endOf('month') : '';
}

/**
 * formats date display
 * @param date
 * @param format
 * @param isUTC
 * @returns {string}
 */
export function format (date, format, isUTC) {
    format = typeof format !== typeof undefined ? format : 'DD-MM-YYYY';
    isUTC = typeof isUTC !== typeof undefined ? isUTC : false;
    var momentDate = isUTC ? moment(moment.utc(date).toDate()).format(format) : moment(date).format(format);
    return momentDate;
}

/**
 * formats financial year end date
 * @param date
 * @returns {string}
 */
export function formatFinancialYearEnd (date) {
    var currentMonth = date.getMonth() + 1,
        monthText = "";
    for (var i = 0; i < months.length; i++) {
        var month = months[i];
        if (parseInt(currentMonth, 10) === parseInt(month.month, 10)) {
            monthText = ucFirst(month.full);
        }
    }
    return date.getDate() + " " + monthText;
}

/**
 * formats financial year end date with year added
 * @param date
 * @returns {string}
 */
export function formatFinancialYearEndWithYear (date) {
    var currentMonth = date.getMonth() + 1,
        monthText = "";
    for (var i = 0; i < months.length; i++) {
        var month = months[i];
        if (parseInt(currentMonth, 10) === parseInt(month.month, 10)) {
            monthText = ucFirst(month.full);
        }
    }
    return date.getDate() + " " + monthText + " " + date.getFullYear();
}

/**
 * formats date of birth
 * @param date
 * @returns {string}
 */
export function formatDateOfBirth (date) {
    var currentMonth = date.getMonth() + 1,
        monthText = "";
    for (var i = 0; i < months.length; i++) {
        var month = months[i];
        if (parseInt(currentMonth, 10) === parseInt(month.month, 10)) {
            monthText = ucFirst(month.full);
        }
    }
    return date.getDate() + " " + monthText + " " + date.getFullYear();
}

/**
 * formats corporate secretary appointment date
 * @param date
 * @returns {string}
 */
export function formatAppointmentDate (date) {
    var convertDateString = new Date(date);
    var currentMonth = convertDateString.getMonth() + 1,
        monthText = "";
    for (var i = 0; i < months.length; i++) {
        var month = months[i];
        if (parseInt(currentMonth, 10) === parseInt(month.month, 10)) {
            monthText = ucFirst(month.full);
        }
    }
    return convertDateString.getDate() + ' ' + monthText + ' ' + convertDateString.getFullYear();
}

/**
 * prepares date for submission to api disregarding all timezone involved
 * @param date
 * @returns {string}
 */
export function formatUTCDateForApi (date) {
    if (notEmpty(date)) {
        date = date instanceof Date ? date : new Date(date);
        // strips timezone date from date string
        // return date.toDateString();
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    } else {
        return '';
    }
}

/**
 * formats credit card expiry date
 * @param date
 * @returns {string}
 */
export function formatCCExpiryDate (date) {
    return (date.getMonth() + 1) + "/" + date.getFullYear();
}

/**
 * add months to a date
 * @param inDate
 * @param monthsToAdd
 * @param returnType
 * @returns {any}
 */
export function addMonthsToDate (inDate, monthsToAdd, returnType) {
    returnType = isEmpty(returnType) ? 1 : returnType;
    var newDate = inDate ? moment(inDate).add({months: monthsToAdd}) : '';
    switch (returnType) {
        // returns moment date object
        default:
        case 1:
            if (isEmpty(newDate)) {
                newDate = moment();
            }
            break;
        // returns javascript date object
        case 2:
            if (!isEmpty(newDate)) {
                return newDate.toDate();
            } else {
                newDate = new Date();
            }
            break;
    }
    return newDate;
}

/**
 * calculate default financial year end date
 * @returns {*|moment.Moment}
 */
export function calculateDefaultFYE_SG () {
    var currentDate = new Date();
    var momentDate = moment(currentDate);
    // add 11 months to current month
    momentDate = addMonthsToDate(momentDate, 11);
    // get last day of month
    momentDate = momentDate.endOf('month');
    return momentDate;
}

/**
 * Format UTC version of datetime to local version of datetime
 * @param {Date|String} utcDateStr
 * @returns {string}
 */
export function formatUTCToLocalDateTime (utcDateStr) {
    if (general.notEmpty(utcDateStr)) {
        var date = utcDateStr instanceof Date ? utcDateStr : new Date(utcDateStr);
        var monthText = '';
        for (var i = 0; i < months.length; i++) {
            var month = months[i];
            if (parseInt((date.getMonth() + 1), 10) === parseInt(month.month, 10)) {
                monthText = general.ucFirst(month.full);
            }
        }
        return date.getDate() + ' ' + monthText + ' ' + date.getFullYear() + ' ' + formatAMPM(date);
    } else {
        return '';
    }
}

/**
 * Format AM/PM in date
 * @param {Date|String} date
 * @returns {string}
 */
export function formatAMPM (date) {
    if (general.notEmpty(date)) {
        date = date instanceof Date ? date : new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    } else {
        return '';
    }
}
/**
 *
 * @param {Date | string} utcDateStr
 */
export function formatUTCToLocalDateTimeWithTimezone (utcDateStr) {
    if (general.notEmpty(utcDateStr)) {
        var date = utcDateStr instanceof Date ? utcDateStr : new Date(utcDateStr);
        var monthText = '';
        for (var i = 0; i < months.length; i++) {
            var month = months[i];
            if (date.getMonth() + 1 === month.month) {
                monthText = general.ucFirst(month.full);
            }
        }
        let timezone = getTimeZoneStringFromDate(date);
        return date.getDate() + ' ' + monthText + ' ' + date.getFullYear() + ' ' + formatAMPM(date) + ` (${timezone})`;
    } else {
        return '';
    }
}
/**
 * Gets the timezone string from date
 * @param {Date} date
 */
function getTimeZoneStringFromDate (date) {
    let date_str = date.toString();
    let timezone_regex = /(\()([^()]+)(\))/;
    let matches = timezone_regex.exec(date_str);
    let timezone_only = matches[2] || '';
    return timezone_only.trim();
};
